module.exports = __webpack_public_path__ + "img/4_159.f0b25e53.png";